import '../../vendor/jquery.vimeo.api'
import '../../vendor/player'
import { gsap } from "gsap";

export default {

    init() {
        /* Script pour le module vidéo avec curseur, preview et ligne élastique */
        if ($(".module-video-content")[0]) {
            $(".module-video-content").each(function() {

                var videoContent = $(this);


                var iframe = videoContent.find('#video');

                if (iframe.length) {

                    var videoContentPlayer = new Vimeo.Player(iframe);

                    var videoContentOverlay = videoContent.find(".embed-container");

                    var overlayClienRect = videoContentOverlay[0].getBoundingClientRect();

                    $(document).ready(function() {
                        videoContentPlayer.setVolume(0);


                        /* Animation de ligne élastique si désirée */
                        if (videoContent.find("#drawContainer")[0]) {
                            elasticLine();
                        }
                    });

                    // Corrige la taille de l'overlay lorsque l'on change la taille de la page
                    $(window).resize(function() {
                        elasticLine();
                    });

                    // Video in pause if the video container is passed
                    if (videoContent.find('[data-pause]').length) {
                        $(window).on('scroll', function() {
                            const windowPosTop = $(this).scrollTop()
                            const heightVideo = overlayClienRect.height
                            const topPosVideo = iframe.offset().top

                            if (windowPosTop >= heightVideo + topPosVideo) {
                                videoContentPlayer.pause();
                            }
                        })
                    }


                    // Transition entre la preview et la vidéo et changement du contenu dans le curseur
                    videoContentOverlay.on("click", function() {
                        videoContentOverlay.toggleClass("played");

                        if (videoContentOverlay.hasClass("played")) {
                            videoContentPlayer.play();

                            if (!$(".audio-button").hasClass("mute")) {
                                videoContentPlayer.setVolume(1);
                            }

                            if ($(".concentrique")[0]) {
                                hideLegend();
                                videoContent.find(".puces").css("visibility", "hidden");

                                videoContent.find(".concentrique").css("visibility", "hidden");

                                setTimeout(function() { videoContent.find(".legend-wrapper").css("display", "none"); }, 1000);

                            }

                        } else {
                            videoContentPlayer.pause();

                            if ($(".concentrique")[0]) {
                                showLegend();
                                videoContent.find(".puces").css("visibility", "visible");

                                videoContent.find(".concentrique").css("visibility", "visible");

                                videoContent.find(".legend-wrapper").css("display", "block");
                            }

                        }
                    })


                    function elasticLine() {
                        // Initialise la taille in-line de l'overlay pour afficher correctement la ligne
                        videoContentOverlay.attr("width", iframe[0].getBoundingClientRect().width);
                        videoContentOverlay.attr("height", iframe[0].getBoundingClientRect().height);

                        if (videoContent.find('#drawContainer')[0]) {
                            const canvasEle = videoContent.find('#drawContainer')[0];
                            const context = canvasEle.getContext('2d');

                            context.strokeStyle = "white";
                            context.lineWidth = 2;

                            // Position fixe d'une l'extrémité de la ligne
                            let startPosition = {
                                x: 300,
                                y: 450
                            };
                            let lineCoordinates = {
                                x: 0,
                                y: 0
                            };
                            let isDrawStart = false;

                            // Récupère les coordonnées du canvas
                            const getClientOffset = (event) => {
                                const {
                                    pageX,
                                    pageY
                                } = event.touches ? event.touches[0] : event;
                                const x = pageX - videoContentOverlay.offset().left;
                                const y = pageY - videoContentOverlay.offset().top;

                                return {
                                    x,
                                    y
                                }
                            }

                            const drawLine = () => {
                                context.beginPath();
                                context.moveTo(startPosition.x, startPosition.y);
                                context.lineTo(lineCoordinates.x, lineCoordinates.y);
                                context.stroke();
                            }

                            const mouseDownListener = (event) => {
                                //startPosition = getClientOffset(event);
                                isDrawStart = true;
                            }

                            // Dessine la ligne avec la position du curseur
                            const mouseMoveListener = (event) => {

                                if (!isDrawStart) return;
                                lineCoordinates = getClientOffset(event);
                                clearCanvas();
                                drawLine();
                            }

                            // Dessine la ligne pour qu'elle aille au centre de la page sur le curseur personnalisé
                            const mouseupListener = () => {
                                isDrawStart = false;

                                var x = overlayClienRect.width / 2 - cursor_custom.width() / 2;
                                var y = overlayClienRect.height / 2;

                                lineCoordinates = {
                                    x,
                                    y
                                };
                                clearCanvas();
                                drawLine();
                            }

                            const clearCanvas = () => {
                                context.clearRect(0, 0, canvasEle.width, canvasEle.height);
                            }

                            // Dessine la ligne initiale au chargement de la page
                            //mouseupListener();
                            // Lorsque la souris se déplace dans le canvas, la ligne se dessine en suivant la souris
                            canvasEle.addEventListener('mousemove', mouseDownListener);
                            canvasEle.addEventListener("mousemove", mouseMoveListener);

                            canvasEle.addEventListener('mouseout', mouseupListener);

                        }

                    }

                    function showLegend() {

                        var animation = gsap.timeline({});

                        animation.to(".legendes>line", {
                            duration: 1,
                            attr: { x2: 230 },
                            ease: "expo.out"
                        });

                        animation.to(".title_legend", {
                            duration: 1,
                            y: -10,
                            opacity: 1,
                            ease: "expo.out"
                        }, "-=0.8");

                        animation.to(".text_legend", {
                            duration: 1,
                            y: 10,
                            opacity: 1,
                            ease: "expo.out"
                        }, "-=0.8");
                        animation.to(".module-button", {
                            duration: 1,
                            y: 10,
                            opacity: 1,
                            ease: "expo.out"
                        }, "-=0.8");

                    }

                    function hideLegend() {
                        var animation = gsap.timeline({});
                        animation.to(".title_legend", {
                            duration: 1,
                            y: 10,
                            opacity: 0,
                            ease: "expo.out"
                        }, 0);
                        animation.to(".text_legend", {
                            duration: 1,
                            y: 20,
                            opacity: 0,
                            ease: "expo.out"
                        }, 0);

                        animation.to(".legendes>line", {
                            duration: 1,
                            attr: { x2: 0 },
                            ease: "expo.out"
                        }, "-=0.8");

                        animation.to(".module-button", {
                            duration: 1,
                            y: 20,
                            opacity: 0,
                            ease: "expo.out"
                        }, 0);
                    }

                    if ($(".concentrique")[0]) {


                        /* Animation de pulsation sur la puce */
                        var anim = gsap.timeline({
                            repeat: -1
                        });
                        anim.to(".concentrique", {
                            duration: 1,
                            scale: 1.5,
                            ease: "expo.out"
                        });
                        anim.to(".concentrique", {
                            duration: 1,
                            opacity: 0,
                            ease: "expo.out"
                        }, "-=0.6");

                        // Animation d'apparition des légendes au clic de la puce
                        videoContent.find(".puces").on('click', function() {

                            if (videoContent.find(".legendes>line").attr("x2") == 0) {
                                showLegend();
                            } else if (videoContent.find(".legendes>line").attr("x2") == 230){
                                hideLegend();
                            }

                        });
                    }
                }
            });
        }
    },
};